import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import { ChangePasswordRequest } from '@app/utils/interfaces/change-passwords.interface';

@Injectable({
  providedIn: 'root',
})
export class ChangePasswordService {
  private readonly baseUrl: string = environment.apiBaseUrl;
  private readonly http: HttpClient = inject(HttpClient);

  public changePassword(passwordsData: ChangePasswordRequest): Observable<null> {
    return this.http.put<null>(`${this.baseUrl}${ApiEndpoints.CHANGE_PASSWORD}`, passwordsData);
  }
}
